import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1>Ecommerce App Development Company</h1>
              <p className="main_para">
                As a leading ecommerce application development company, we
                specialize in crafting bespoke solutions that propel your brand
                to new heights. So partner with TekRevol and unlock the
                potential of your online business with our innovative solutions
                and expertise in e-commerce mobile app development. Gain 10X
                conversions through digitizing your businesses with our custom
                Ecommerce application development.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
